import axios from 'axios';

export const uploadFile = async file => {
  const url =
    'https://qa-cabinet.post.kz/cabinet/dp-le-cabinet/api/v1/npi-part?lang=kk';

  const formData = new FormData();
  formData.append('multipartFiles', file);
  const response = await axios.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data; // Return the response data
};

export default uploadFile;
